import { render } from "./ExpressDetailDialog.vue?vue&type=template&id=8b18c764&scoped=true"
import script from "./ExpressDetailDialog.vue?vue&type=script&lang=js"
export * from "./ExpressDetailDialog.vue?vue&type=script&lang=js"

import "./ExpressDetailDialog.vue?vue&type=style&index=0&id=8b18c764&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8b18c764"

export default script